import { useLazyQuery } from "@apollo/client/react";
import { useCallback, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { GET_BUSCAR_PACIENTES } from "../../../data/graphQL/queries/BuscarPaciente/getBuscarPaciente";

export const useGetRows = (filters, setIsRefetchRequired) => {
  const [rows, setRows] = useState([]);

  const [getBuscarPaciente, { loading: buscarPacienteLoading, data: dataBuscarPaciente }] = useLazyQuery(GET_BUSCAR_PACIENTES, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (dataBuscarPaciente) {
      const pacientes = dataBuscarPaciente.pacientesSearch?.valorEsperado || [];
      setRows(pacientes);
      setIsRefetchRequired(false);
    }
  }, [dataBuscarPaciente]);

  const handleSearch = useCallback((firstRender) => {
    if (!filters.nombre && !filters.apellido && !filters.codigoSap && !filters.dni && !filters.afiliado) {
      if (!firstRender) toast.error("Por favor, ingresa al menos un filtro para buscar");
      return;
    }

    getBuscarPaciente({ variables: { filter: filters } });
  }, [filters, getBuscarPaciente]);

  return {
    rows,
    setRows,
    loading: buscarPacienteLoading,
    totalCount: rows?.length || 0,
    handleSearch
  };
};